import { registerTranslationRefresh, t as lnT } from '../i18n';
export const AUDIO_TRANSCRIPTION_OUTPUT_FORMAT = Object.freeze({
    PLAIN: 'PLAIN',
    TIMESTAMPED: 'TIMESTAMPED',
    SUMMARIZED: 'SUMMARIZED'
});

const makeTranslatedAUDIO_TRANSCRIPTION_OUTPUT_OPTIONS = () => ([
    {
        value: AUDIO_TRANSCRIPTION_OUTPUT_FORMAT.PLAIN,
        menuLabel: lnT('messages:transcribe'),
        label: lnT('messages:plainText'),
        description: lnT('messages:saveTheTranscriptAsNormalText')
    },
    {
        value: AUDIO_TRANSCRIPTION_OUTPUT_FORMAT.TIMESTAMPED,
        hidden: true,
        menuLabel: lnT('messages:timestamps'),
        label: lnT('messages:timestamps'),
        description: lnT('messages:saveTheTranscriptWithTimeMarkers')
    },
    {
        value: AUDIO_TRANSCRIPTION_OUTPUT_FORMAT.SUMMARIZED,
        menuLabel: lnT('messages:summarize'),
        label: lnT('messages:summarize'),
        description: lnT('messages:saveASummaryOnTopAndThe')
    }
]);
export let AUDIO_TRANSCRIPTION_OUTPUT_OPTIONS = makeTranslatedAUDIO_TRANSCRIPTION_OUTPUT_OPTIONS();
registerTranslationRefresh(() => { AUDIO_TRANSCRIPTION_OUTPUT_OPTIONS = makeTranslatedAUDIO_TRANSCRIPTION_OUTPUT_OPTIONS(); });

const makeTranslatedAUDIO_TRANSCRIPTION_VISIBLE_OPTIONS = () => (AUDIO_TRANSCRIPTION_OUTPUT_OPTIONS.filter(
    option => !option.hidden
));
export let AUDIO_TRANSCRIPTION_VISIBLE_OPTIONS = makeTranslatedAUDIO_TRANSCRIPTION_VISIBLE_OPTIONS();
registerTranslationRefresh(() => { AUDIO_TRANSCRIPTION_VISIBLE_OPTIONS = makeTranslatedAUDIO_TRANSCRIPTION_VISIBLE_OPTIONS(); });
